import { Button } from 'antd';
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { WarningOutlined } from '@ant-design/icons';
import ResetModal from './ResetModal';
import { useTranslation } from 'react-i18next';
import StepperModel from '../../models/StepperModel';
import { STEP_SITE_BUILDER } from '../../steps/steps-definitions';
import SiteBuilderModel from '../../steps/SiteBuilder/model/SiteBuilderModel';
import ScreenNavigationModel, { ScreenType } from '../../steps/FindYourBusiness/models/ScreenNavigationModel';


interface FCProps {}

const ResetWizard: React.FC<FCProps> = observer(({}) => {
  const { t } = useTranslation();
  const [resetModalVisible, setResetModalVisible] = React.useState(false);
  
  const isLiveEnvironment = process.env.NODE_ENV === 'production' && process.env.APPLICATION_ENV !== 'testing';
  
  const isSiteBuilderIframeMode = 
    StepperModel.currentStep === STEP_SITE_BUILDER && 
    SiteBuilderModel.iframeVisibility;
  const isCompanySelectionScreen =
    ScreenNavigationModel.currentScreen === ScreenType.SELECT_YOUR_COMPANY;
  
  if (ScreenNavigationModel.currentScreen === ScreenType.SEARCH_FOR_BUSINESS || 
      (isSiteBuilderIframeMode && isLiveEnvironment)) {
    return null;
  }
  
  return (
    <>
      <div
        className={`mt-5 sm:flex sm:flex-col sm:items-center sm:justify-center ${
          isSiteBuilderIframeMode ? 'reset-wizard-preview' : ''
        }`}>
        <Button
          {...(isCompanySelectionScreen
            ? {
                id: 'company-selection-reset',
                'data-ga-event': 'company-selection-reset'
              }
            : {})}
          className="flex items-center justify-center"
          type="link"
          onClick={() => {
            setResetModalVisible(true);
          }}>
          {t('Reset form')}
        </Button>

        <ResetModal
          visible={resetModalVisible}
          setVisible={setResetModalVisible}
        />
      </div>
    </>
  );
});

export default ResetWizard;
